import { render } from "./AssistantComposer.vue?vue&type=template&id=16c56b58&scoped=true"
import script from "./AssistantComposer.vue?vue&type=script&lang=js"
export * from "./AssistantComposer.vue?vue&type=script&lang=js"

import "./AssistantComposer.vue?vue&type=style&index=0&id=16c56b58&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16c56b58"]])

export default __exports__